import React, { useEffect, useState } from "react";
import assets from "../../../assets/assets";
import { IconController } from "../../Scripts/ImgController";

const Song = ({ song, selectedSongs }) => {
  const [songChecked, setSongChecked] = useState(false);
  const songUncheckHandler = (id) => {
    const index = selectedSongs.indexOf(id);
    if (index > -1) {
      selectedSongs.splice(index, 1);
    }
    setSongChecked(false);
  };
  const songCheckHandler = (id) => {
    selectedSongs.push(id);
    setSongChecked(true);
  };
  useEffect(() => {
    if (selectedSongs.includes(song.id)) {
      setSongChecked(true);
    }
  }, []);
  return (
    <div className="flex flex-row gap-2" key={song.id}>
      {songChecked ? (
        <div
          onClick={() => {
            songUncheckHandler(song.id);
          }}
        >
          <IconController
            src={assets.svg.checkboxChecked}
            className="w-5 h-5 cursor-pointer"
          />
        </div>
      ) : (
        <div
          className="checkbox-unchecked"
          onClick={() => {
            songCheckHandler(song.id);
          }}
        ></div>
      )}
      <h5 className="text-xs truncate">{song.title}</h5>
    </div>
  );
};

export default Song;
